import React from 'react';
import { Link } from 'react-router-dom';
import { FaBookOpen, FaMapMarkerAlt, FaRegCalendarCheck } from 'react-icons/fa';
import forumPhoto from '../assets/eicForum/face-to-face-with-editors.jpg';
import './EICForumPage.css';

const editorsInChief = [
  { journal: 'Thin-Walled Structures', editor: 'Prof Nuno Silvestre' },
  { journal: 'Journal of Building Engineering', editor: 'Prof Halil Sezen' },
  { journal: 'Journal of Constructional Steel Research', editor: 'Prof Ben Young' },
  { journal: 'Earthquake Engineering and Structural Dynamics', editor: 'Prof Xinzheng Lu' },
  { journal: 'Construction and Building Materials', editor: 'Prof Jose Adam' },
  { journal: 'Case Studies in Construction Materials', editor: 'Prof Tianyu Xie' },
  { journal: 'Engineering Structures', editor: 'Prof Jie Yang' },
  { journal: 'International Journal of Structural Stability and Dynamics', editor: 'Prof CM Wang & Prof YB Yang' },
];

const EICForumPage = () => {
  return (
    <section className="eic-page fade-in-up">
      <div className="eic-wrapper">
        <span className="badge eic-badge">Speakers</span>
        <h1 className="eic-heading">Editors-in-Chief's Forum</h1>
        <p className="eic-subtitle">
          Editors-in-Chief of leading structural engineering journals will come together for a
          dedicated forum at ICES2026, giving delegates a rare opportunity to hear directly from the
          journals shaping the field &mdash; followed by an open discussion with the audience.
        </p>

        {/* Featured photo */}
        <figure className="eic-photo">
          <img src={forumPhoto} alt="Editors-in-Chief panel discussion at a structural engineering forum" />
          <figcaption>Face to Face with Editors</figcaption>
        </figure>

        {/* Editors-in-Chief in attendance */}
        <div className="eic-section">
          <div className="eic-section-header">
            <div className="eic-section-icon editors-icon">
              <FaBookOpen />
            </div>
            <h2 className="eic-section-title">Editors-in-Chief in Attendance</h2>
          </div>
          <div className="eic-editors-grid">
            {editorsInChief.map((item, index) => (
              <div className="eic-editor-card" key={index}>
                <div className="eic-editor-journal">{item.journal}</div>
                <div className="eic-editor-name">{item.editor}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Session details & program */}
        <div className="eic-section">
          <div className="eic-section-header">
            <div className="eic-section-icon details-icon">
              <FaMapMarkerAlt />
            </div>
            <h2 className="eic-section-title">Session Details &amp; Program</h2>
          </div>
          <div className="eic-details-card">
            <p className="eic-details-note">
              For date, time and venue, please refer to the conference program.
            </p>
            <Link to="/information/program" className="eic-program-link">
              <FaRegCalendarCheck />
              <span>View Conference Program</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EICForumPage;
